import { RoadmapPhase } from '../types/roadmap';

export const roadmapData: RoadmapPhase[] = [
  {
    period: 'Q2 2024',
    title: 'Project Launch',
    objective: 'Establish RentFi\'s foundation in the real estate market',
    items: [
      'Initial property acquisitions in target markets',
      'Development of core business strategy',
      'Formation of key partnerships with real estate agencies',
      'Legal framework establishment'
    ]
  },
  {
    period: 'Q3-Q4 2024',
    title: 'Market Establishment',
    objective: 'Build strong operational foundation',
    sections: [
      {
        subtitle: 'Property Portfolio',
        items: [
          'Continued strategic property acquisitions',
          'Establishment of property management systems',
          'First rental income generation'
        ]
      },
      {
        subtitle: 'Community & Marketing',
        items: [
          'Social media presence launch',
          'Educational content development',
          'Community engagement initiatives'
        ]
      },
      {
        subtitle: 'Technical Development',
        items: [
          'Smart contract development and audits',
          'Platform infrastructure development',
          'Integration with Solana ecosystem'
        ]
      }
    ]
  },
  {
    period: 'Q1 2025',
    title: 'Token Launch Phase',
    objective: 'Integrate blockchain technology with existing operations',
    sections: [
      {
        subtitle: 'Token Launch',
        items: [
          'RENT token deployment on Solana',
          'Initial liquidity provision on Raydium (5M tokens)',
          'Integration of existing properties with token ecosystem'
        ]
      },
      {
        subtitle: 'Documentation System',
        items: [
          'Launch of secure documentation vault',
          'Implementation of real-time portfolio tracking',
          'Deployment of analytics dashboard'
        ]
      }
    ]
  },
  {
    period: 'Q2 2025',
    title: 'Ecosystem Growth',
    objective: 'Expand digital infrastructure',
    sections: [
      {
        subtitle: 'Technical Development',
        items: [
          'Enhanced analytics and reporting systems',
          'Automated distribution processes implementation',
          'Smart contract renouncement'
        ]
      },
      {
        subtitle: 'Portfolio Expansion',
        items: [
          'Accelerated property acquisitions',
          'Geographic diversification',
          'Yield optimization strategies'
        ]
      },
      {
        subtitle: 'Community Building',
        items: [
          'Educational content',
          'Host expert webinar series to engage and educate early investors'
        ]
      }
    ]
  },
  {
    period: 'Q3 2025',
    title: 'Governance Implementation',
    objective: 'Transition to community governance',
    sections: [
      {
        subtitle: 'DAO Structure',
        items: [
          'Governance framework launch',
          'Voting mechanism implementation',
          'Community proposal system'
        ]
      },
      {
        subtitle: 'Portfolio Development',
        items: [
          'Advanced risk assessment framework',
          'Market analysis tools integration'
        ]
      },
      {
        subtitle: 'Community Growth',
        items: [
          'Global partnership expansion',
          'Enhanced educational resources',
          'Regular community events'
        ]
      }
    ]
  },
  {
    period: 'Q4 2025',
    title: 'Full Ecosystem Maturity',
    objective: 'Scale operations globally',
    sections: [
      {
        subtitle: 'Advanced Features',
        items: [
          'Mobile app development',
          'Advanced analytics integration'
        ]
      },
      {
        subtitle: 'Market Expansion',
        items: [
          'Institutional partnerships',
          'Enhanced liquidity solutions'
        ]
      },
      {
        subtitle: 'DAO Activation',
        items: [
          'First community property acquisition votes',
          'Governance incentive programs'
        ]
      }
    ]
  },
  {
    period: '2026',
    title: 'Vision',
    objective: 'Establish RentFi as a global leader in blockchain-powered real estate',
    sections: [
      {
        subtitle: 'Property Portfolio',
        items: [
          'Manage over 100 properties with diversified types and geographies',
          'Achieve optimized yields and risk-adjusted returns with a focus on sustainability'
        ]
      },
      {
        subtitle: 'Technology',
        items: [
          'Full automation of processes and advanced analytics capabilities',
          'Strengthen mobile presence with cross-platform accessibility and real-time optimization'
        ]
      },
      {
        subtitle: 'Community',
        items: [
          'Build an active, globally present DAO with strong partnerships',
          'Offer an education platform, research resources, and market insights',
          'Host community-driven events to foster engagement'
        ]
      }
    ]
  }
];